import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { put, select, takeLatest } from "redux-saga/effects";

import { callApi } from "../../../../sagas";
import State from "../../../../State";
import { Cognito } from "../../../../utils/cognito";
import errors from "../../../../utils/errors";
import * as actions from "./actions";
import { CANCEL_FUELING_PROCESS } from "./constants";

const getAccessToken = (state: State): string =>
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  state.session.session!.credentials.accessToken;

function* cancelFuelingProcess(
  axiosClient: AxiosInstance,
  cognito: Cognito,
  action: actions.CancelFuelingProcessAction
) {
  try {
    const accessToken: string = yield select(getAccessToken);
    const requestConfig: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      validateStatus: () => true,
    };

    const response: AxiosResponse<{ type?: string; message?: string }> =
      yield callApi(
        cognito,
        accessToken,
        axiosClient.post,
        `/support/processes/${action.fuelingProcessId}/state`,
        {
          state: "rejected",
          description: action.description,
        },
        requestConfig
      );

    const responseType = response.data?.type ?? "error";

    if (responseType === "ok") {
      yield put(actions.hideFuelingProcessCancelEdit());
    } else {
      yield put(
        actions.cancelFuelingProcessFailed(
          responseType,
          response.data?.message ?? ""
        )
      );
    }
  } catch (error) {
    yield put(
      actions.cancelFuelingProcessFailed("error", errors.toString(error))
    );
  }
}

export function* watchCancelFuelingProcess(
  axiosClient: AxiosInstance,
  cognito: Cognito
) {
  yield takeLatest(
    CANCEL_FUELING_PROCESS,
    cancelFuelingProcess,
    axiosClient,
    cognito
  );
}
